<mat-toolbar color="primary">
  <button *ngIf="!this.pollingConnection || this.pollingConnection.closed" mat-raised-button #connect (click)="openSettings()">
    Connect
  </button>
  <button *ngIf="this.pollingConnection?.closed == false" mat-raised-button #disconnect (click)="handleDisconnect('Disconnected!')">
    Disconnect
  </button>
</mat-toolbar>
